module.exports = __webpack_public_path__ + "img/public_dropdown_up_blue.20660d00.svg";